import { FILE_MAX_SIZE, VALID_TYPES_FILE } from "../../../../constants/constants";

const validateForSize = (file) => (file.size / 1024) <= FILE_MAX_SIZE;
const validateForType = (file) =>  VALID_TYPES_FILE.includes(file.type);

export const checkFileValidations = (file) => {
    const allValidations = [
        { validation: validateForSize, errorMessage: 'validationSizeError' },
        { validation: validateForType, errorMessage: 'hidden' },
    ];

    return allValidations.reduce((acc, { validation, errorMessage }) => {
        const successValidation = validation(file);
        return successValidation ? acc : errorMessage;
    }, '');
};
